// Recently viewed: listings, creators and events you opened, kept on this device only (never sent anywhere).
const KEY = "fable.recent.v1";
const MAX = 12;

export function getRecent() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; }
}

export function recordView(item) {
  if (!item || !item.id || !item.url) return;
  try {
    const rest = getRecent().filter((x) => !(x.type === item.type && x.id === item.id));
    localStorage.setItem(KEY, JSON.stringify([{ ...item, at: Date.now() }, ...rest].slice(0, MAX)));
    window.dispatchEvent(new Event("fable:recent"));
  } catch (e) { /* storage blocked */ }
}

export function clearRecent() {
  try { localStorage.removeItem(KEY); window.dispatchEvent(new Event("fable:recent")); } catch (e) { /* storage blocked */ }
}
